import {QUEUE_OPERATOR_UPDATE, QUEUE_PRIMARY_UPDATE, QUEUE_SECONDARY_UPDATE, QUEUES_RESET} from "./actionTypes";

export const updatePrimaryQueue = (atendimentos) => ({type: QUEUE_PRIMARY_UPDATE, payload: atendimentos});
export const updateSecondaryQueue = (atendimentos) => ({type: QUEUE_SECONDARY_UPDATE, payload: atendimentos});
export const updateOperatorQueue = (atendimentos) => ({type: QUEUE_OPERATOR_UPDATE, payload: atendimentos});
export const resetQueues = () => ({type: QUEUES_RESET});
